<template>
  <AGAutocomplete
    id="autocomplete_classificacao_analise"
    v-model="localValue"
    label="Classificação de análise"
    item-title="title"
    item-value="value"
    :items="items"
    :hint="hint"
    :disabled="disabled"
    :multiple="multiple"
    :has-select-all="hasSelectAll"
    :rules="rules"
    :message-color="messageColor"
    :has-select-group="hasSelectGroup"
  />
</template>

<script>
import AGAutocomplete from '@/components/common/AGAutocomplete.vue';
import { MESSAGE_COLOR } from '@/constants/ConstantMessageColor';

export default {
  components: { AGAutocomplete },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Boolean, String, Number, Array, Object, null],
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hasSelectAll: {
      type: Boolean,
      default: false,
    },
    messageColor: {
      type: String,
      default: MESSAGE_COLOR.DEFAULT,
      validator: (val) => Object.values(MESSAGE_COLOR).includes(val),
    },
    hasSelectGroup: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    items() {
      const CLASSIFICACAO_ANALISE = {
        EM_ANALISE: { title: 'Em análise' },
        PENDENTE_DE_ESCLARECIMENTO: { title: 'Requer esclarecimento' },
        ANALISANDO: { title: 'Analisando', isGroup: true },
        RISCO_DETECTADO: { title: 'Com risco', groupId: 'ANALISANDO' },
        INEXPRESSIVO: { title: 'Inexpressivo', groupId: 'ANALISANDO' },
      };

      return Object.keys(CLASSIFICACAO_ANALISE).map((key) => ({
        id: key,
        value: key,
        title: CLASSIFICACAO_ANALISE[key].title,
        groupId: CLASSIFICACAO_ANALISE[key].groupId,
        isGroup: CLASSIFICACAO_ANALISE[key].isGroup,
      }));
    },
  },
};
</script>
